"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/**
 * Catches render errors in the child tree and shows fallback UI so the app does not blank screen.
 */
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'development') {
            console.error('ErrorBoundary caught:', error?.message, errorInfo?.componentStack);
        }
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback)
                return this.props.fallback;
            return ((0, jsx_runtime_1.jsxs)("div", { style: {
                    padding: 40,
                    textAlign: 'center',
                    color: '#666',
                    maxWidth: 480,
                    margin: '40px auto',
                }, role: "alert", children: [(0, jsx_runtime_1.jsx)("p", { style: { margin: '0 0 16px', fontWeight: 600 }, children: "Something went wrong" }), (0, jsx_runtime_1.jsx)("p", { style: { margin: 0, fontSize: 14 }, children: this.state.error?.message || 'An unexpected error occurred.' })] }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
